import axios from 'axios'
import moment from 'moment'

export const getReportList = async () => {
  const url = 'https://api.gazetadopovo.com.br/api/v2/report/offersdashboard/sales_month/'

  const formData1 = new FormData()
  formData1.set('offer_id', 4739)
  formData1.set('date_ini', '2019-01-01')
  formData1.set('date_end', '2022-01-01')

  const formData2 = new FormData()
  formData2.set('offer_id', 4740)
  formData2.set('date_ini', '2019-01-01')
  formData2.set('date_end', '2022-01-01')

  const formData3 = new FormData()
  formData3.set('offer_id', 4800)
  formData3.set('date_ini', '2019-01-01')
  formData3.set('date_end', '2022-01-01')

  const formData4 = new FormData()
  formData4.set('offer_id', 4801)
  formData4.set('date_ini', '2019-01-01')
  formData4.set('date_end', '2022-01-01')

  const res1 = await axios.post(url, formData1)
  const res2 = await axios.post(url, formData2)
  const res3 = await axios.post(url, formData3)
  const res4 = await axios.post(url, formData4)

  let data = []

  if (res1.data.data) {
    data = res1.data.data.oferta
  }
  if (res2.data.data) {
    data = data.concat(res2.data.data.oferta)
  }
  if (res3.data.data) {
    data = data.concat(res3.data.data.oferta)
  }
  if (res4.data.data) {
    data = data.concat(res4.data.data.oferta)
  }

  return data.sort((a, b) => {
    if (moment(a.data_cadastro) === moment(b.data_cadastro)) {
      return 0
    }
    return moment(a.data_cadastro) > moment(b.data_cadastro) ? -1 : 1
  })
}
